/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    CANCEL: 'Annuler',
    CONFIRM: 'Confirmer',
    SAVE: 'Sauvegarder'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Lien',
    SOCIAL_NETWORK: 'Réseau social',
    USERNAME: 'Nom d\'utilisateur'
  },
  LABEL: {
    CREATE_LINK: 'Ajouter réseau social',
    EDIT_LINK: 'Modifier réseau social',
    INACTIVATE_LINK: 'Supprimer réseau social',
    INACTIVATE_LINK_MODAL_TITLE: 'Supprimer réseau social',
    LINK: 'Lien',
    SOCIAL_NETWORK: 'Réseau social',
    USERNAME: 'Nom d\'utilisateur'
  },
  SENTENCE: {
    ERROR: 'Erreur',
    INACTIVATE_LINK_TEXT: 'Es-tu sûr de vouloir supprimer ce réseau social?',
    NO_ROWS_LINKS: 'Aucun réseaux sociaux'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Le réseau social a été supprimé avec succès',
    LINKS_DETAILS_SAVED: 'Le réseau social a été enregistré avec succès',
    LINKS_DETAILS_UPDATED: 'Le réseau social a été mis à jour avec succès',
    SUCCESS: 'Succès'
  },
  TOOLTIP: {
    LINK: 'Lien',
    SOCIAL_NETWORK: 'Réseau social',
    USERNAME: 'Nom d\'utilisateur'
  }
};
